
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getObjectsInRadius"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4626ac7b510b5871ac3e.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			